import { modifier } from 'ember-modifier';

export default modifier(function setElement(
  element,
  [handler, destroyHandler]
) {
  if (!handler) {
    console.error(
      'set-element modifier requires a handler function',
      new Error().stack
    );
    return;
  }
  handler(element);
  if (!destroyHandler) {
    return;
  }
  return () => {
    destroyHandler(element);
  };
});
